import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type EnhancedLocation from 'owa-service/lib/contract/EnhancedLocation';

export const getEnhancedLocations = (event: CalendarEvent) => (): EnhancedLocation[] => {
    return event.Locations;
};
